import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { DATA_PER_PAGE, CANCEL, File_deleted } from './../../../../app.constant';
import { Urls } from '../../../../utils/catalogue/urls';
import { ApiService } from '../../../../shared/catalogue/services/api.service';
import { CommonDataService } from '../../../../shared/catalogue/services/common-data.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forms-scheme-documents',
  templateUrl: './forms-scheme-documents.component.html',
  styleUrls: ['./forms-scheme-documents.component.scss'],
})
export class FormsSchemeDocumentsComponent implements OnInit, OnChanges {
  @Input() data: any[];

  schemeDocsPDFsData = [];

  pageSize: number = DATA_PER_PAGE;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.data) {
      this.filterPdf(this.data);
    }
  }

  getDocs = () => {
    this.apiService
      .getData(Urls.getSubSectiondocs)
      .subscribe((response: any) => {
        this.filterPdf(response.data.list);
      });
  };

  public filterPdf(data: any[]) {
    const schemeDocsPDFsData = data.filter((pdf) => {
      return pdf.type === 'Scheme Documents' || pdf.type === '6';
    });

    this.schemeDocsPDFsData = [...schemeDocsPDFsData];
  }

  public viewFile(path) {
    window.open(path, '_blank');
  }

  public deleteData(data) {
    const obj = {
      type: data.type,
      id: data.id,
    };
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteSubSectionDocuments, obj)
            .subscribe(
              (response) => {
                this.toastr.success(File_deleted);
                this.getDocs();
              },
              (error) => {}
            );
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  }
}
